import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, AsyncPipe } from '@angular/common';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';


import {
  AppAsideModule,
  AppBreadcrumbModule,
  //BreadcrumbModule,
  AppHeaderModule,
  //HeaderModule,
  AppFooterModule,
  //FooterModule,
  AppSidebarModule,
  //SidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgChartsModule } from 'ng2-charts';
import { ToastrModule } from 'ngx-toastr';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';



// firebase staffs
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCn96CE6G7JGK1LF8jVGoQHBKx0cDUBX3w",
  authDomain: "smart-logger-mcu.firebaseapp.com",
  databaseURL: "https://smart-logger-mcu.firebaseio.com",
  projectId: "smart-logger-mcu",
  storageBucket: "smart-logger-mcu.appspot.com",
  messagingSenderId: "844237252065",
  appId: "1:844237252065:web:6c2a10edf6786a90ab1ea0"
};

// Firebase Test
const firebaseConfigTest = {
  apiKey: 'AIzaSyDosAsUOuE6iOytGTe-nAOcT3H7SVSD5Pg',
  authDomain: 'node-mcu-test-c7bf6.firebaseapp.com',
  databaseURL: 'https://node-mcu-test-c7bf6.firebaseio.com',
  projectId: 'node-mcu-test-c7bf6',
  storageBucket: 'node-mcu-test-c7bf6.appspot.com',
  messagingSenderId: '743307316902',
  appId: '1:743307316902:web:e6df8f5fef7069a233ae67'
};

// Services imports
import { ChartService } from '../app/services/chart.service';
import { MessagingService } from '../app/services/messaging.service';

// guard import
import { AuthGuard } from '../app/core/auth.guard';
import { HomeComponent } from './views/home/home.component';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?cb=' + 0.4);
  // cb=0.4 is the version, because the navigator can use old cached .json traduction.
  // https://github.com/ngx-translate/core/issues/1143#issuecomment-724790398
}


// To hide typescript error "Property 'msSaveBlob' does not exist"
declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}


@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    // BreadcrumbModule,
    // FooterModule,
    // HeaderModule,
    // SidebarModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppHeaderModule,
    AppFooterModule,
    AppSidebarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    NgChartsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingBarRouterModule,
    AlertModule.forRoot(),

    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    DragDropModule,
    NgbModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    HomeComponent,


  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    ChartService,
    MessagingService,
    AsyncPipe,
    AuthGuard,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
